import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-torino',
  templateUrl: './sessione-torino.component.html',
  styleUrls: ['./sessione-torino.component.css']
})
export class SessioneTorinoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
